import { AddCircleOutline } from "@mui/icons-material";
import { styled, Tooltip, tooltipClasses } from "@mui/material";
import PropTypes from "prop-types";
import React, { useContext } from "react";

import { FollowUpDispatchContext } from "../../context/FollowUpContext";
import { CONTENT_ADD_FOLLOWUP, showContent, toggleDialog } from "../../state/actions";

import { TooltipStyling } from "./InfoTooltip/TooltipStyling";

const Header = ({ id, title, showAddButton }) => {
  const dispatch = useContext(FollowUpDispatchContext);

  const HtmlInfoTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(() => ({
    [`& .${tooltipClasses.tooltip}`]: TooltipStyling,
  }));

  const showDialog = (value) => {
    showContent(dispatch, value);
    toggleDialog(dispatch, true);
  };

  return (
    <div id={id + "_Header"} data-testid={id + "_Header"} className="flex">
      <div className="w-[90%]">{title}</div>
      <div className="flex w-[10%] flex-row">
        <HtmlInfoTooltip title={"Add Follow Up"}>
          <>
            {showAddButton && (
              <AddCircleOutline
                className="text-green-500 hover:text-green-800"
                onClick={() => showDialog(CONTENT_ADD_FOLLOWUP)}
              />
            )}
          </>
        </HtmlInfoTooltip>
      </div>
    </div>
  );
};

Header.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  showAddButton: PropTypes.bool,
};

export default Header;
